import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals_action/affiliate-signup/stage';
import {AffiliateSignup} from '../../../reducers/modals-action/actions';
import PurpleButton from '../../components/purple-button';
import FormInput from '../../components/form-input';

export default ({game, close}) => {
    const {error, button} = useSelector(Selector),
          dispatch = useDispatch();

    const [data, setData] = useState({
        phone: '',
        username: '',
        password: ''
    })

    return (
        <div className="action-modal-body-container">
            <div className="modal-body stage-body">
                <div className="stage-header">
                    <div className="left">
                        <div className="title">Sign Up to Play</div>
                        <div className="text">Lock in your spot and get ready for the rush.</div>
                    </div>
                    <div className="close" onClick={e => close()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                {error && (
                    <div class="modal-message warning">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span dangerouslySetInnerHTML={{__html: error}}></span>
                    </div>
                )}


                <div className="form-group">
                    <FormInput
                            name="phone"
                            type={'tel'}
                            label={null}
                            placeholder={'(198) 765 43-21'}
                            defaultValue={data.phone}
                            isPhone={true}
                            validators={[
                                (value) => {
                                    value = value.replace(/[^0-9]/gi, '');
                                    return value.length === 10;
                                }
                            ]}
                            onChange={({value, validator}) => setData({...data, phone: value.replace(/[^0-9]/gi, '')})} />

                    <FormInput
                        name="username"
                        type={'text'}
                        label={null}
                        placeholder={'Username'}
                        defaultValue={data.username}
                        validators={[
                            (value) => value.replace(/[^a-z0-9_]/gi, '').length > 6
                        ]}
                        onChange={({value, validator}) => setData({...data, username: value.replace(/[^a-z0-9_]/gi, '')})} />

                    <FormInput
                        name="password"
                        type={'password'}
                        label={null}
                        placeholder={'Password'}
                        defaultValue={data.password}
                        validators={[
                            value => value.length > 7,
                            value => value.replace(/[^a-z]/gi, '').length > 0,
                            value => value.replace(/[^0-9]/gi, '').length > 0
                        ]}
                        onChange={({value, validator}) => setData({...data, password: value})} />
                </div>

                <PurpleButton active={button} onClick={e => {
                    dispatch(AffiliateSignup.signUp({
                        ...data,
                        game: game.slug
                    }));
                }}>
                    Sign Up
                </PurpleButton>

                <div className="stage-progress">
                    <div className="game-select">
                        <div className="left">
                            <div className="image">
                                <img src={`${window.location.origin}/source/system/games/${game.slug}.png`} />
                            </div>
                            <div className="game-info">
                                <div className="label">Game Selected</div>
                                <div className="value">{game.name}</div>
                            </div>
                        </div>
                    </div>
                    <div className="map">
                        <div className="dot active"></div>
                        <div className="line active"></div>
                        <div className="dot active"></div>
                        <div className="line"></div>
                        <div className="dot active"></div>
                        <div className="line"></div>
                        <div className="dot active bonus selected">
                            <img src={`${window.location.origin}/source/system/modals-action/affiliate-signup/gift.png`} />
                        </div>
                    </div>
                    <div className="stages">
                        <span>Choose game</span>
                        <span className="active">Sign Up</span>
                        <span>Notifications</span>
                        <span>Claim Bonus</span>
                    </div>
                </div>
            </div>
        </div>
    )
}